import { Loader } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function BootstrapLoadingOverlay() {
  const { t } = useTranslation();
  const loadingLabel = t("Loading...");

  return (
    <div role="status" aria-live="polite" aria-label={loadingLabel}>
      <Loader overlay label={loadingLabel} aria-label={loadingLabel} />
    </div>
  );
}
